// Writes a cookie with 'name' and 'value'.
// Options:
// - longLasting (bool): set the cookie to last for a long term
// - expirationDays (int): number of days the cookie should last
// - path (string) - the /path to scope the cookie to
// - domain (string) - the domain to scope the cookie to
export function setCookie(name, value, options = {}) {
  let expirationDays
  const miliSecondsInADay = 24 * 60 * 60 * 1000

  if (options.longLasting) {
    expirationDays = 10 * 365 // arbitrary number... 10 years should work for most cases
  } else if (options.expirationDays) {
    expirationDays = options.expirationDays
  } else {
    expirationDays = 1 // default
  }

  const expires = new Date()
  const durationInMili = expirationDays * miliSecondsInADay
  expires.setTime(expires.getTime() + durationInMili)

  let cookie = `${name}=${value};expires=${expires.toUTCString()}`

  if (options.domain) {
    cookie += `;domain=${options.domain}`
  }

  if (options.path) {
    cookie += `;path=${options.path}`
  }

  document.cookie = cookie
}

export function getCookie(name) {
  const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))

  if (!cookie) {
    return null
  }

  return decodeURIComponent(cookie.split('=')[1])
}
